<script setup lang="ts">
import { ResourceType, type ResourceData } from '@/dataManager'
import VueFeather from 'vue-feather';
import { dataManager } from '@/dataManager';

const props = defineProps<{
  resource: ResourceData
}>()

const dm = dataManager.getInstance()

</script>

<template>
  <p class="resource">
    <a :href="resource.url" target="_blank" @click="dm.registerResourceClicked(resource.id)">
      <VueFeather v-if="resource.type == ResourceType.Video" type="video"/>
      <VueFeather v-if="resource.type == ResourceType.Document" type="file-text"/>
      <VueFeather v-if="resource.type == ResourceType.Image" type="image"/>
      <span>{{ resource.title }}</span>
    </a>
  </p>
</template>

<style scoped>
p.resource {
  width: 100%;

  margin-top: 10px;
  border: 2px solid var(--main-color);
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  margin: 10px 0;

  a {
    color: black;
    text-decoration: none;
    display: flex;
  }

  &:hover, &:active {
    background-color: #ffc39b;
  }
  i {
    color: var(--main-color);
    padding-right: 10px;
    flex-shrink: 0;
  }
}
</style>
